<mat-dialog-content>
  <div class="modal">
    <mat-stepper linear #stepper>
      <mat-step [stepControl]="durationFormGroup" [editable]="true">
        <form [formGroup]="durationFormGroup" class="duration-form">
          <ng-template matStepLabel>Availability Duration</ng-template>

          <div class="info">
            <div class="text-center med-gray-text">
              <span class="item-name">TURNING </span>
              <span class="item-name">{{ data.isAvailable ? "ON" : "OFF" }}</span>
            </div>
            <div class="item-name">{{ data.itemName }} / {{ data.itemDescription }}</div>

            <div class="sub-id">#{{ data.commerceItemNumber }}</div>
          </div>

          @if (isAvailable(data)) {
            <div>
              <div class="cache-message alert alert-danger item-name">
                It may take up to 15 minutes for Modifier to appear OFF in the customer application.
              </div>
              <div class="item-name">
                We will automatically turn the Modifier back ON at the start of the selected business day.
                <br /><br />
                Please select a time frame:
              </div>
              <mat-button-toggle-group formControlName="duration">
                <mat-button-toggle value="1">Tomorrow</mat-button-toggle>
                <mat-button-toggle value="2">In 2 Days</mat-button-toggle>
                @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin", "Division"])) {
                  <mat-button-toggle value="0">Until Further Notice</mat-button-toggle>
                }
              </mat-button-toggle-group>
            </div>
          }

          @if (!isAvailable(data)) {
            <div class="item-name">Please enter a reason for the change.</div>
          }
          <div>
            <mat-form-field class="reason">
              <mat-label>Reason (Required)</mat-label>
              <input matInput type="text" formControlName="reason" />
            </mat-form-field>
          </div>
          @if (authManager.doesCurrentAccountHaveAnyRole(["Division", "IT", "Admin"])) {
            <div>
              <div class="multi-radio">
                <div class="item-name">
                  Would you like to turn this item {{ data.isAvailable ? "on" : "off" }} for multiple stores?
                </div>
                <mat-radio-group
                  class="radio-group"
                  [(ngModel)]="isMultiStore"
                  [ngModelOptions]="{ standalone: true }"
                  (change)="multiStoreButton($event)"
                  name="multi-store">
                  <mat-radio-button [value]="true" name="multi-store">
                    Yes, I would like to apply this change to multiple stores.
                  </mat-radio-button>
                  <mat-radio-button checked [value]="false" name="multi-store">
                    No, only apply changes to this store.
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          }
          <div class="button-container">
            <button mat-button matStepperPrevious (click)="onNoClick()" type="button">Cancel</button>

            @if (!isMultiStore) {
              <button
                mat-button
                matStepperNext
                mat-raised-button
                color="accent"
                (click)="updateAvailability()"
                [disabled]="durationFormGroup.status === 'INVALID'">
                Confirm
              </button>
            }

            @if (isMultiStore) {
              <button
                mat-button
                matStepperNext
                mat-raised-button
                color="accent"
                [disabled]="!isDurationClickable"
                (click)="markDurationFormTouched()">
                Select Stores
              </button>
            }
          </div>
        </form>
      </mat-step>
      @if (isMultiStore) {
        <mat-step [stepControl]="facilitiesFormGroup" [editable]="true">
          <form>
            <ng-template matStepLabel>Select Stores</ng-template>
            <div class="info">
              <div class="text-center med-gray-text">
                <span>TURNING </span>
                <span class="bold">{{ data.isAvailable ? "ON" : "OFF" }}</span>
              </div>
              <div class="item-name">{{ data.itemName }} / {{ data.itemDescription }}</div>
              <div class="sub-id">#{{ data.commerceItemNumber }}</div>
            </div>
            <multi-store-dropdown
              [(facilities)]="facilities"
              [currentFacilityId]="currentFacilityId"
              (validationCheck)="facilityValidation()">
            </multi-store-dropdown>
            <div class="button-container">
              <button mat-button matStepperPrevious type="button" [disabled]="!isClickable">Back</button>
              <button
                mat-button
                matStepperNext
                mat-raised-button
                color="accent"
                (click)="updateAvailability()"
                [disabled]="!isClickable">
                Confirm
              </button>
            </div>
          </form>
        </mat-step>
      }
    </mat-stepper>
  </div>
</mat-dialog-content>
